<template>
  <div id="rico">
    <img id="shadow" src="../assets/svg/shadow.svg" />
    <img id="eye" src="../assets/svg/eye.png" />
    <div id="eye-mask">
      <div id="eye-container" v-bind:class="this.class">
        <div id="eyeball">
          <img id="iris" src="../assets/svg/iris.svg" />
          <img id="pupil" src="../assets/svg/pupil.svg" />
        </div>
      </div>
      <div id="shadow-mask" />
    </div>
  </div>
</template>

<script>
import { randomBytes } from 'crypto';
export default {
  name: 'rico',
  data () {
    return {
      class: {
        left : false,
        right: false,
        kick: false,
        reset: false,
        blink: false,
        look: false,
        blinkReset: false
      },
      mouseX: 0.5,
      mouseY: 0.5,
      floatHeight: 47,
      floatDirection: 0.1
    }
  },
  created: function () {
    setTimeout(this.look, Math.random() * 3000);
    setTimeout(this.blink, Math.random() * 5000);
    setTimeout(this.focus, Math.random() * 5000);
    setTimeout(this.float, 1000);
    const self = this;
    document.onmousemove = function (event) {
        self.mouseX = event.pageX / window.innerWidth;
        self.mouseY = event.pageY / window.innerHeight;
      };
  },
  methods: {
    look: function () {
      var y = this.mouseX - 0.5;
      var x = - this.mouseY + 0.5;
      var dist = Math.sqrt(x*x + y*y) * 2;
      x += Math.random() * 0.1 - 0.05;
      y += Math.random() * 0.1 - 0.05;
      var angle = (Math.random() * 30 + 5 + (25*dist));
      var scale = 1- (5/4000) * angle;
      var time = Math.random() * 1200 + 400;
      document.querySelector("#eye-mask").style.setProperty("--xlook", x);
      document.querySelector("#eye-mask").style.setProperty("--ylook", y);
      document.querySelector("#eye-mask").style.setProperty("--angle", angle + "deg");
      document.querySelector("#eye-mask").style.setProperty("--scaleAmount", scale);
      document.querySelector("#eye-mask").style.setProperty("--anim", "all " + time + "ms");
      this.class.look = true;
      if(Math.random() > 0.9) {
        setTimeout(() => {
          this.focus();
          setTimeout(this.look, Math.random() * 1000 + 1000);
        }, time);
      } else if(Math.random() > 0.8) {
        setTimeout(() => {
          this.squint();
          setTimeout(this.look, Math.random() * 1000 + 2000);
        }, time);
      } else {
        setTimeout(this.look, Math.random() * 1000 + time);
      }
    },
    kick: function () {
      this.class.kick = true;
      setTimeout(() => {
        this.class.kick = false;
        this.class.reset = true;
        setTimeout(() => {
          this.class.reset = false;
        }, 10);
      }, 1990);
    },
    blink: function () {
      document.querySelector("#eyeball").style.setProperty("opacity", 0.1);
      setTimeout(() => {
        document.querySelector("#eyeball").style.setProperty("opacity", 1);
        if(Math.random() > 0.8) {
          setTimeout(() => {
            this.blink();
          }, 200);
        } else {
          setTimeout(this.blink, Math.random() * 7000 + 1000);
        }
      }, 70);
    },
    focus: function () {
      document.querySelector("#eye-mask").style.setProperty("--pupilScale", 1.05);
      setTimeout(() => {
        document.querySelector("#eye-mask").style.setProperty("--pupilScale", 1);
      }, 500);
    },
    squint: function () {
      document.querySelector("#eye-mask").style.setProperty("--pupilScale", 0.95);
      document.querySelector("#eye-mask").style.setProperty("--irisScale", 0.95);
      setTimeout(() => {
        document.querySelector("#eye-mask").style.setProperty("--pupilScale", 1);
        document.querySelector("#eye-mask").style.setProperty("--irisScale", 1);
      }, 1500);
    },
    float: function () {
      if(this.floatHeight <= 49 && this.floatHeight >= 45) {
        this.floatHeight += this.floatDirection;
      } else {
        this.floatDirection *= -1;
        this.floatHeight += this.floatDirection;
      }
      document.querySelector("#eye").style.setProperty("transform", "translate(-50%, -" + this.floatHeight + "%)")
      document.querySelector("#eye-mask").style.setProperty("transform", "translate(-50%, -" + this.floatHeight + "%)")
      setTimeout(this.float, Math.random() * 50 + 75);
    }
  }
}
</script>

<style scoped>
#eye-mask {
  --anim: all 0.4s;
  --animTime: 1s;
  --xlook: 1;
  --ylook: 1;
  --angle: 40deg;
  --scaleAmount: 0.95;
  --pupilScale: 1;
  --irisScale: 1;
  --pupilHeight: 100%;
}

#shadow {
  position: absolute;
  top: 93%;
  left: 0%;
  width: 100%;
  height: 13.88%;
}

#eye {
  position: absolute;
  top: 44.44%;
  left: 50%;
  width: 100%;
  height: 88.88%;
  transform: translate(-50%, -47%);
}

#eye-mask {
  position: absolute;
  top: 44.1%;
  left: 50%;
  border-radius: 50%;
  overflow: hidden;
  width: 100.7%;
  height: 89.7%;
  transform: translate(-50%, -47%);
}

#eyeball {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 44.44%;
  height: 44.44%;
  transform: translate3d(-50%, -50%, 160px);
  /* opacity: 0.5; */
}

#pupil {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: var(--pupilHeight);
  transition: transform 0.5s ease-out;
  transform: translate(-50%, -50%) scale(var(--pupilScale));
}

#iris {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  transition: transform 0.5s ease-out;
  transform: translate(-50%, -50%) scale(var(--irisScale));
}

#shadow-mask {
  background-image: linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.15)
  );
  position: absolute;
  z-index: 5000;
  height: 100%;
  width: 100%;
}

#eye-container {
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 50%;
  /* background: black; */
  width: 100%;
  height: 100%;
  /* perspective: 800px; */
  transform-style: preserve-3d;
  transition: var(--anim);
  transition-timing-function: ease-in-out;
  backface-visibility: hidden;
}

#eye-container.look {
  transition: var(--anim);
  transition-timing-function: ease-in-out;
  transform: rotate3d(var(--xlook), var(--ylook), 0, var(--angle))
    scale(var(--scaleAmount));
}

#eye-container.kick {
  transition: all 1s;
  transition-timing-function: ease-out;
  transform: rotate3d(1, 1, 0, 720deg);
}

#eye-container.reset {
  transition: all 0s;
  transform: rotate3d(1, 1, 0, 0deg);
}

#eye-container.blink {
  opacity: 0;
}

#eye-container.blinkReset {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/rico.vue